module.exports = __webpack_public_path__ + "static/health-smart-behavior-year-2-0eb828cb6e09cd7d3774cd967ef53a0c.jpg";